import Button from '../../elements/ButtonLink/ButtonLink';
import IcUpdateStock from '../../icons/IcUpdateStock';
import React from 'react';
import styles from './styles.scoped.css';
import IlluEmptyPaper from '../../icons/IlluEmptyPaper';

export default function EmptySyncStock(){
  return(
    <div className={styles.container}>
      <IlluEmptyPaper />
      <h5>Belum Ada Riwayat Inject Stok</h5>
      <Button className={styles.btnIcon} outlined to="/merchant/update-stock-merchant/upload">
        <IcUpdateStock classname={'icon'} /> Inject Data Stok Pangkalan</Button>
    </div>
  );
}
